import { Component, ViewChild } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../globals";
import { CustomersServices } from "../services";
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationServices } from '../../configuration/services';
import { ConfigurationTicketsListPage } from '../../configuration/configuration-tickets/configuration-tickets-list/configuration-tickets-list';
import { HttpClient } from '@angular/common/http';
import { InvoicesViewPage } from '../../invoices/invoices-view/invoices-view';
import { InvoicesCreateSelectTicketsPage } from '../../invoices/invoices-create/invoices-create-select-tickets/invoices-create-select-tickets';
import { AddonsTriggerVersionProPage } from '../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';

/**
 * Generated class for the ProductListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'customers-tickets-invoices-list',
  templateUrl: 'customers-tickets-invoices-list.html',
})
export class CustomersTicketsInvoicesListPage {

  element_type: any = 'open';
  searchbar_text: string = '';
  tab: any;

  customer_uid: any;
  list_tickets: any;
  list_invoices: any;

  customer_name: any;
  customer_phone: any;
  //datatable tickets
  sorts_tickets = [
    { prop: 'number', dir: 'asc' },
    { prop: 'date', dir: 'asc' },
    { prop: 'cash_static', dir: 'asc' },
    { prop: 'type', dir: 'asc' },
    { prop: 'payment_type', dir: 'asc' },
    { prop: 'amount', dir: 'asc' }
  ];
  sorts_invoices = [
    { prop: 'customer', dir: 'asc' },
    { prop: 'invoice_number', dir: 'asc' },
    { prop: 'total', dir: 'asc' },
    { prop: 'payed', dir: 'asc' }
  ];
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;
  config_msg = {
    emptyMessage: this.translate.instant('general-no-hay-datos'),
    totalMessage: this.translate.instant('general-total'),
    selectedMessage: this.translate.instant('general-seleccionado')
  };

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public configurationServices: ConfigurationServices,
    public globals: Globals,
    public loadingCtrl: LoadingController,
    public translate: TranslateService,
    public http: HttpClient,
    public customersServices: CustomersServices) {
  }

  ionViewWillEnter() {
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: this.translate.instant('instant-cargando-tickets')
    });
    loadingPopup.present();
    this.customer_uid = this.navParams.get('customer_uid');
    this.tab = this.navParams.get('tab');
    this.customer_name = this.navParams.get('customer_name');
    this.customer_phone = this.navParams.get('customer_phone');

    this.getAllInfoFromNode();
    loadingPopup.dismiss();
  }

  getAllInfoFromNode() {
    switch (this.tab) {
      case 0: {
        this.getTicketsFromCustomer();
        break;
      }
      case 1: {
        this.getInvoicesFromCustomer();
        break;
      }
    }
  }

  getTicketsFromCustomer() {
    this.customersServices.getPagesCustomerTickets(this.customer_uid);
  }

  getInvoicesFromCustomer() {
    this.customersServices.getPagesCustomerInvoices(this.customer_uid);
  }

  openTicket(event) {
    if (event.type == 'click') {
      this.navCtrl.push(ConfigurationTicketsListPage, {
        state: 'closed',
        ticket: event.row,
      });
    }
  }

  openInvoice(event) {
    if (event.type == 'click') {
      this.navCtrl.push(InvoicesViewPage, {
        'type': 'pay',
        'invoice': event.row,
      });
    }
  }

  createInvoice() {
    if (this.globals.checkLimitsByLicense('tpv', 'invoices')) {
      this.navCtrl.push(InvoicesCreateSelectTicketsPage, {
        tickets: this.customersServices.tickets_array,
        customer_uid: this.customer_uid
      });
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  onSortTickets(event) {
    var tickets_array = this.customersServices.tickets_array_tmp;

    switch (event.column.name) {
      case 'number':
        if (event.newValue == 'asc') {
          tickets_array.sort((a, b) => a.number - b.number);
        } else {
          tickets_array.sort((a, b) => b.number - a.number);
        }
        break;
      case 'date':
        if (event.newValue == 'asc') {
          tickets_array.sort((a, b) => this.globals.timestampToDate(a.date).localeCompare(this.globals.timestampToDate(b.date)));
        } else {
          tickets_array.sort((a, b) => this.globals.timestampToDate(b.date).localeCompare(this.globals.timestampToDate(a.date)));
        }
        break;
      case 'cash_static':
        if (event.newValue == 'asc') {
          tickets_array.sort((a, b) => a.cash_static.localeCompare(b.cash_static));
        } else {
          tickets_array.sort((a, b) => b.cash_static.localeCompare(a.cash_static));
        }
        break;
      case 'type':
        if (event.newValue == 'asc') {
          tickets_array.sort((a, b) => a.type.localeCompare(b.type));
        } else {
          tickets_array.sort((a, b) => b.type.localeCompare(a.type));
        }
        break;
      case 'payment_type':
        if (event.newValue == 'asc') {
          tickets_array.sort((a, b) => a.payment_type.localeCompare(b.payment_type));
        } else {
          tickets_array.sort((a, b) => b.payment_type.localeCompare(a.payment_type));
        }
        break;
      case 'amount':
        if (event.newValue == 'asc') {
          tickets_array.sort((a, b) => a.amount - b.amount);
        } else {
          tickets_array.sort((a, b) => b.amount - a.amount);
        }
        break;
    }

    this.customersServices.tickets_array_tmp = tickets_array;
  }


  onSortInvoices(event) {
    var invoices_array = this.customersServices.invoices_array_filtered;

    switch (event.column.name) {
      case 'customer':
        if (event.newValue == 'asc') {
          invoices_array.sort((a, b) => a.customer.localeCompare(b.customer));
        } else {
          invoices_array.sort((a, b) => b.customer.localeCompare(a.customer));
        }
        break;
      case 'invoice_number':
        if (event.newValue == 'asc') {
          invoices_array.sort((a, b) => a.invoice_number - b.invoice_number);
        } else {
          invoices_array.sort((a, b) => b.invoice_number - a.invoice_number);
        }
        break;
      case 'total':
        if (event.newValue == 'asc') {
          invoices_array.sort((a, b) => a.total - b.total);
        } else {
          invoices_array.sort((a, b) => b.total - a.total);
        }
        break;
      case 'payed':
        if (event.newValue == 'asc') {
          invoices_array.sort((a, b) => a.payed - b.payed);
        } else {
          invoices_array.sort((a, b) => b.payed - a.payed);
        }
        break;
    }

    this.customersServices.invoices_array_filtered = invoices_array;
  }

  trFontColor(ticket) {
    if (ticket.refund && ticket.amount < 0) {
      let cssClasses = {
        'text-danger': true,
      };
      return cssClasses;
    }
    return '';
  }

  searchTicketsNode(event) {
    const searchText = event.target.value.toLowerCase();
    this.customersServices.invoices_array_filtered = this.customersServices.invoices_array.filter(invoice => {
      return (
        invoice.customer.toLowerCase().includes(searchText) ||
        invoice.invoice_number.toString().toLowerCase().includes(searchText) ||
        invoice.total.toString().includes(searchText)
      );
    });
  }
}




// WEBPACK FOOTER //
// ./src/pages/customers/customers-tickets-invoices-list/customers-tickets-invoices-list.ts